export const BIPOLAR_MIN_STATEMENTS = 1;
export const BIPOLAR_MAX_STATEMENTS = 20;
export const BIPOLAR_MIN_SCALEPOINTS = 2;
export const BIPOLAR_MAX_SCALEPOINTS = 20;

export const BIPOLAR_STATEMENT_STEP = 1;
export const BIPOLAR_SCALEPOINT_STEP = 1;

export const BIPOLAR_DEFAULT_COUNT_STATEMENTS = 2;
export const BIPOLAR_DEFAULT_COUNT_SCALEPOINTS = 3;

export const BIPOLAR_SLIDER_MIN_STATEMENTS = 2;
export const BIPOLAR_SLIDER_MAX_STATEMENTS = 20;
export const BIPOLAR_SLIDER_MIN_SCALEPOINTS = 3;
export const BIPOLAR_SLIDER_MAX_SCALEPOINTS = 11;

export const BIPOLAR_SLIDER_SCALEPOINT_STEP = 2;
export const BIPOLAR_SLIDER_DEFAULT_COUNT_SCALEPOINTS = 3;
export const BIPOLAR_SLIDER_DEFAULT_COUNT = 5;

export const BIPOLAR_STYLES = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  SLIDER: 'SLIDER',
};
